import React from "react";
import FuelTransactionsView from "../components/FuelTransactionsView";

// Every fuel purchase recorded from the mobile app. Read-only: purchases are
// never edited, only reviewed or voided from the detail modal.
const FuelTransactionsPage = () => (
  <FuelTransactionsView
    title="Fuel Transactions"
    subtitle="Fuel purchases recorded in the mobile app, each with its odometer and pump photos - click a row for the detail"
  />
);

export default FuelTransactionsPage;
